import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "tokenInput", "deleteButton", "errorMessage", "form"]
  static values = { expectedToken: String }

  connect() {
    var self = this;
    // Close modal on Escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        self.closeModal();
      }
    });
  }

  openModal() {
    var modal = this.modalTarget;
    var tokenInput = this.tokenInputTarget;
    var deleteButton = this.deleteButtonTarget;
    var errorMessage = this.errorMessageTarget;

    modal.style.display = 'block';
    tokenInput.value = '';
    tokenInput.focus();
    deleteButton.disabled = true;
    errorMessage.style.display = 'none';
  }

  closeModal() {
    var modal = this.modalTarget;
    var tokenInput = this.tokenInputTarget;
    var errorMessage = this.errorMessageTarget;

    modal.style.display = 'none';
    tokenInput.value = '';
    errorMessage.style.display = 'none';
  }

  validateToken() {
    var self = this;
    var tokenInput = this.tokenInputTarget;
    var deleteButton = this.deleteButtonTarget;
    var errorMessage = this.errorMessageTarget;
    var expectedToken = this.expectedTokenValue;
    var enteredToken = tokenInput.value.trim();

    if (enteredToken === expectedToken) {
      deleteButton.disabled = false;
      errorMessage.style.display = 'none';
    } else {
      deleteButton.disabled = true;
      if (enteredToken.length > 0) {
        errorMessage.style.display = 'block';
      } else {
        errorMessage.style.display = 'none';
      }
    }
  }

  submitForm(event) {
    // Form will submit normally, validation happens on server side too
    // This method is here if we need to do any additional validation
  }
}
